import React from 'react'
import StepBubble from './StepBubble'

const StepsGroup = ({ steps, type, handlePreviousClick }) => {
  if (!steps || steps.length === 0) {
    return null
  }

  return (
    <div className="steps-group">
      {steps.map((step) => (
        <StepBubble
          key={`${step.title}-${step.stepIndex}`}
          type={type}
          step={step.stepIndex + 1}
          onClick={type === 'previous' ? handlePreviousClick(step.stepIndex) : null}
        />
      ))}
    </div>
  )
}

export default StepsGroup
